export default __webpack_public_path__ + "static/media/ic_properties.fe834b14.png";